<template>
  <div>
    <b-container class="view-container">
      <br>
      <div class="warning alert alert-info" role="alert" v-if="user.status === 401">
        Du verkar inte ha åtkomst eller så har din inloggning löpt ut. Prova att logga in på nytt, men om det fortfarande inte fungerar behöver du begära åtkomst för att kunna logga in till Stöd vid läkemedelshantering.
      </div>
      <div v-if="user.isAuthenticated" class="text-center">
        <h4>Du är inloggad!</h4>
        <router-link to="/">Gå till startsidan</router-link>
      </div>
      <b-form v-else>
        <h1 class="text-center">Inloggning</h1>
        <p>För att logga in trycker du på knappen nedan. Du kommer då att vidarebefordras till Region Skånes inloggningssida.</p>
        <b-button @click="submit(model)" block>Logga in</b-button>
      </b-form>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'SignIn',
  data () {
    return {
      model: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    submit () {
      window.location = process.env.BASE_URL + 'authentication'
    }
  }
}
</script>

<style scoped>
  a {
    text-decoration: underline
  }
</style>
